import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=26b6efa0&"
import script from "./PageNav.vue?vue&type=script&lang=js&"
export * from "./PageNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports